import { render, staticRenderFns } from "./PromoteSubscription.vue?vue&type=template&id=025f3c6c&"
import script from "./PromoteSubscription.vue?vue&type=script&lang=ts&"
export * from "./PromoteSubscription.vue?vue&type=script&lang=ts&"
import style0 from "./PromoteSubscription.vue?vue&type=style&index=0&id=025f3c6c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports